export default __webpack_public_path__ + "static/media/sk_1.995a34f4.jpg";